var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 6.5C14.625 8.55197 13.5262 10.3473 11.885 11.3298C12.5099 11.5318 13.1144 11.7998 13.6879 12.1308C15.1132 12.9535 16.297 14.1368 17.1202 15.5618C17.2929 15.8607 17.1906 16.2429 16.8917 16.4156C16.5928 16.5883 16.2105 16.486 16.0379 16.1871C15.3244 14.952 14.2984 13.9264 13.063 13.2134C11.8277 12.5004 10.4264 12.125 8.99999 12.125C7.57362 12.125 6.17246 12.5003 4.93708 13.2133C3.70171 13.9263 2.67572 14.9519 1.96218 16.1869C1.7895 16.4858 1.40723 16.5881 1.10835 16.4154C0.809463 16.2428 0.707152 15.8605 0.879827 15.5616C1.7031 14.1366 2.88688 12.9534 4.31224 12.1307C4.8857 11.7997 5.49013 11.5318 6.11496 11.3298C4.47372 10.3473 3.37499 8.55196 3.37499 6.5C3.37499 3.3934 5.89339 0.875 8.99999 0.875C12.1066 0.875 14.625 3.3934 14.625 6.5ZM4.62499 6.5C4.62499 4.08375 6.58374 2.125 8.99999 2.125C11.4162 2.125 13.375 4.08375 13.375 6.5C13.375 8.91625 11.4162 10.875 8.99999 10.875C6.58374 10.875 4.62499 8.91625 4.62499 6.5Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.22d60a72.svg";
export { ForwardRef as ReactComponent };